import React, { forwardRef } from 'react';

/**
 * APEX Design System — Input
 *
 * Champ texte standard.
 *
 * Props:
 *   - label   : label au-dessus du champ (optionnel)
 *   - hint    : texte d'aide en dessous (optionnel)
 *   - error   : message d'erreur (rouge, en dessous)
 *   - leftIcon: icône à gauche (optionnel)
 *   - type    : standard HTML (text, email, password, number...)
 *
 * Usage:
 *   <Input
 *     label="Email"
 *     type="email"
 *     value={email}
 *     onChange={(e) => setEmail(e.target.value)}
 *     placeholder="ton@email.com"
 *   />
 */

const Input = forwardRef(function Input({
  label,
  hint,
  error,
  leftIcon,
  type = 'text',
  className = '',
  ...rest
}, ref) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-semibold">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500 pointer-events-none">
            {leftIcon}
          </div>
        )}
        <input
          ref={ref}
          type={type}
          className={`
            w-full bg-zinc-900 border
            ${error ? 'border-rose-400' : 'border-zinc-800 focus:border-cyan-400'}
            text-white p-2.5 ${leftIcon ? 'pl-9' : ''}
            font-mono text-sm
            focus:outline-none transition
            placeholder:text-zinc-600
            disabled:opacity-40 disabled:cursor-not-allowed
          `}
          {...rest}
        />
      </div>
      {(hint || error) && (
        <div className={`text-[10px] font-mono ${error ? 'text-rose-400' : 'text-zinc-500'}`}>
          {error || hint}
        </div>
      )}
    </div>
  );
});

export default Input;
